import {connect} from 'react-redux'
import {Loader, modal, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Button, ButtonToolbar, Col, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import {withRouter} from "react-router";
import * as opravneniActions from "../../actions/opravneniActions";
import * as uzivatelActions from "../../actions/uzivatelActions";
import * as EnumRole from "../../api/gen/cgo/EnumRole";
import {toastr} from "react-redux-toastr";
import SubjektApi from "../../api/gen/cgo/SubjektApi";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - Uživatelé - Impot z AD
 */
class AdSyncPage extends Component<WithTranslation> {

    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        this.props.dispatch(uzivatelActions.fetchAdImportIfNeeded());
    };

    handleDoImportAd = () => {
        const {t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('loading_employees_from_ad'),
                t('starting_loading_employees_from_ad'),
                () => {
                    this.props.dispatch(modal.ModalActions.showAsyncWaiting(
                        t('please_wait'),
                        <Loader>Probíhá načtení pracovníků z AD...</Loader>,
                        SubjektApi.importUsersFromAD(), () => {
                            toastr.info(t('successful_loading_employees_from_ad'));
                        }
                    ));
                },
                null,
                t('confirm')
            )
        );
    };

    render() {
        const {loggedInUser, adImport, t} = this.props;
        let content;
        if (!loggedInUser.fetched || !adImport.fetched) {
            content = <Loader/>;
        } else {
            const enabled = adImport.data.enabled;
            const role = loggedInUser.data.role;
            content = role === EnumRole.ADMIN && <Button disabled={!enabled} color="primary" onClick={this.handleDoImportAd}>{t('start_import_from_ad')}</Button>
        }

        return <AdminPage
            title={t('ad_sync')}
            subtitle={t('users_ad_sync')}
            content={
                <div>
                    <Row>
                        <Col xs={9}>
                            <ButtonToolbar>
                                {content}
                            </ButtonToolbar>
                        </Col>
                    </Row>
                </div>
            }
        />
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        adImport: utils.storeFromArea(state, uzivatelActions.AD_IMPORT_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(AdSyncPage)));

